// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ReactUseIntercom = require("./ReactUseIntercom");

function useIntercom(prim) {
  return ReactUseIntercom.useIntercom();
}

function isBannerVisible() {
  return Stdlib_Option.isSome(Primitive_option.fromNullable(document.querySelector(`iframe[name="intercom-banner-frame"]`)));
}

function getBannerHeight() {
  return Stdlib_Option.getOr(Stdlib_Option.map(Primitive_option.fromNullable(document.querySelector(`iframe[name="intercom-banner-frame"]`)), element => element.getBoundingClientRect().height), 0);
}

exports.useIntercom = useIntercom;
exports.isBannerVisible = isBannerVisible;
exports.getBannerHeight = getBannerHeight;
/* ./ReactUseIntercom Not a pure module */
